import graphql__2bcbc71308e047371b66 from "./__generated__/StepDetails_step.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import ProgressBar from "../Utils/ProgressBar";
import { getProgressBetweenDates } from "../../helpers/DateHelpers";
import parseDate from "../Utils/parseDate";
import { useDateRangeMessage } from "../Utils/dateRangeMessage";
import { useUniqueId } from "../Utils/uniqueId";
import { useResponsiveFlag } from "../Utils/ResponsiveQueries";
import { useFormatMessage } from "../Intl/Context";

const StepDetails = ({ displayNumber = true, displayDates = true, ...props }) => {
  const step = useFragment(StepDetails_step, props.step);
  const { isCurrent, name: stepName } = step;

  const { forceWhiteBackground, forceColumnDisplay, seeAllLink } = props;

  const domId = useUniqueId("step-details");
  const { isDesktop } = useResponsiveFlag();

  const t = useFormatMessage();
  const seeAllLabel = t(intlMessages.seeAll);

  const startDate = step.startDate && parseDate(step.startDate);
  const endDate = step.endDate && parseDate(step.endDate);
  const stepNumber = step.position + 1;
  const progress = getProgressBetweenDates(startDate, endDate);
  const isComplete = progress === 100;

  const stepClassName = classNames(
    "d-flex",
    "step-details",
    "card-list-item",
    "padding-md",
    {
      "step-details-complete": isComplete,
      "bg-primary-10": isCurrent && !forceWhiteBackground,
      "with-see-all-link": seeAllLink,
      "align-items-center": isDesktop,
      "flex-column": !isDesktop || forceColumnDisplay
    }
  );

  const stepNumberClassName = classNames("step-details-number", "text-sign", {
    "bg-primary": isCurrent,
    "text-light": isCurrent,
    "bg-primary-20": !isCurrent,
    "text-primary": !isCurrent
  });

  const dateRangeMessage = useDateRangeMessage();
  const datesLabel = displayDates && dateRangeMessage(step.startDate, step.endDate);

  const titleClassName = classNames([
    "d-flex",
    "flex-2",
    "clearfix",
    "margin-right-sm",
    { "align-items-center": isDesktop }
  ]);

  const displayProgressBar = isCurrent && startDate && endDate;

  return (
    <span className={stepClassName}>
      <span className={titleClassName}>
        {displayNumber && (
          <span className="step-details-left">
            <span className={stepNumberClassName}>{stepNumber}</span>
          </span>
        )}

        <span className="step-details-right d-flex justify-content-center">
          <span id={domId} className="step-details-description text-black">
            {stepName}
          </span>

          {datesLabel && (
            <span className="step-details-dates text-legend text-primary">
              {datesLabel}
            </span>
          )}
        </span>
      </span>

      {displayProgressBar && (
        <span className="flex-3 w-100" data-tip="Progression">
          <span className="step-details-right step-details-progress-bar py-3">
            <ProgressBar stepDetailsId={domId} progress={progress} />
          </span>
        </span>
      )}

      {seeAllLink && (
        <span className="text-legend text-primary padding-left-sm text-right nowrap">
          {seeAllLabel}
        </span>
      )}
    </span>
  );
};

const StepDetails_step = graphql__2bcbc71308e047371b66;

export default StepDetails;

const intlMessages = defineMessages({
  seeAll: {
    id: "steps.details.seeAll",
    defaultMessage: "Voir les étapes"
  }
});
